import React from 'react';

interface DeleteConfirmationModalProps {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
    show,
    onConfirm,
    onCancel,
    title = 'Επιβεβαίωση Διαγραφής',
    message = 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την οντότητα; Η ενέργεια αυτή δεν μπορεί να αναιρεθεί.',
    confirmText = 'Διαγραφή',
    cancelText = 'Ακύρωση',
}) => {
    return (
        <div
            className={`modal fade ${show ? 'show' : ''}`}
            tabIndex={-1}
            style={{ display: show ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title text-danger">{title}</h5>
                        <button type="button" className="btn-close" onClick={onCancel}></button>
                    </div>
                    <div className="modal-body">
                        <p>{message}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onCancel}>
                            {cancelText}
                        </button>
                        <button type="button" className="btn btn-danger" onClick={onConfirm}>
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
